import React from "react";
import { Box, Button, Menu, MenuItem, Modal, Typography } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import styles from "./View.module.css";
import moment from "moment";
// Removed material-ui-popup-state; using controlled MUI Menu
import { useSelector } from "react-redux";
import { approveProspect, rejectProspect } from "_controllers/officer";
import { toastMessage } from "utils/toastMessage";

const messageStyle = {
  position: "fixed",
  top: 0,
  right: 0,
  height: "100%",
  overflowY: "auto",
  width: "80%",
  bgcolor: "#ffffff",
  border: "none",
  boxShadow: 24,
  pt: 2,
  pb: 0,
  pl: 4,
  pr: 4,
  textAlign: "left",
  letterSpacing: 1,
};

const DealerProspectView = ({ handleClose, data, remarkAction, setReload }) => {
  let user = useSelector((state) => state.user);
  console.log("data", data);

  const locationScore = (data) => {
    console.log("inside", data);
    if (
      data === "Main Road" ||
      data === "Transportation Hub" ||
      data === "Commercial Market"
    ) {
      return 10;
    } else if (data === "Near Main Road") {
      return 8;
    } else {
      return 6;
    }
  };

  const potentialScore = (data) => {
    if (data?.length > 0) {
      let sumOfSAS = data.reduce((accumulator, currentValue) => {
        currentValue.proposedBusinessByCategory.forEach((item) => {
          accumulator += parseInt(item.sas);
        });
        return accumulator;
      }, 0);
      if (sumOfSAS >= 2500000) {
        return 20;
      } else if (sumOfSAS >= 1500000 && sumOfSAS < 2500000) {
        return 16;
      } else if (sumOfSAS >= 500000 && sumOfSAS < 1500000) {
        return 12;
      } else {
        return 6;
      }
    } else {
      return 6;
    }
  };

  const jkpotentialScore = (data, jksas) => {
    let sumOfSAS = data.reduce((accumulator, currentValue) => {
      currentValue.proposedBusinessByCategory.forEach((item) => {
        accumulator += parseInt(item.sas);
      });
      return accumulator;
    }, 0);
    if (jksas >= 0.3 * sumOfSAS) {
      return 10;
    } else if (jksas >= 0.15 * sumOfSAS && jksas < 0.3 * sumOfSAS) {
      return 8;
    } else if (jksas < 0.15 * sumOfSAS) {
      return 6;
    }
  };

  const experinceScore = (data) => {
    if (parseInt(data) > 5) {
      return 10;
    } else if (parseInt(data) >= 2 && parseInt(data) <= 5) {
      return 8;
    } else {
      return 6;
    }
  };

  const reputationScore = (data) => {
    if (data) {
      if (data.toLowerCase() == "highly reputed") {
        return 10;
      }
      if (data.toLowerCase() == "no negative feedback but average relations") {
        return 8;
      }
      if (data.toLowerCase() == "lack of positive feedback") {
        return 6;
      } else {
        return 6;
      }
    } else {
      return 0;
    }
  };

  const industryScore = (data) => {
    if (data) {
      let compArray = [];
      data.map((n) => {
        compArray.push(n.toLowerCase());
      });
      console.log(compArray);
      if (
        compArray.includes("apollo") ||
        compArray.includes("mrf") ||
        compArray.includes("jk")
      ) {
        return 10;
      } else if (
        compArray.includes("bridgestone") ||
        compArray.includes("ceat") ||
        compArray.includes("michelin") ||
        compArray.includes("goodyear") ||
        compArray.includes("TVS") ||
        compArray.includes("continental") ||
        compArray.includes("ralco")
      ) {
        return 8;
      } else {
        return 6;
      }
    } else {
      return 6;
    }
  };

  const CustomProgessBar = ({ size, value, color, type }) => {
    const circumference = 2 * 115 * 3.14 * (value <= 50 ? 50 : value) * 0.01;
    return (
      <>
        <div
          style={{
            position: "relative",
          }}
        >
          <svg width={size} height={size} viewBox="0 0 250 250">
            <circle
              className="bg"
              cx="125"
              cy="125"
              r="115"
              fill="none"
              stroke="#ddd"
              stroke-width="20"
            ></circle>
            <circle
              className="fg"
              cx="125"
              cy="125"
              r="115"
              fill="none"
              stroke={color}
              stroke-width="20"
              stroke-dasharray={circumference}
            ></circle>
          </svg>
          <div
            style={{
              position: "absolute",
              top: 6,
              left: 5,
            }}
          >
            {Math.trunc(value)}
          </div>
          <div
            style={{ fontSize: "12px", textAlign: "center", fontWeight: "600" }}
          >
            {type}
          </div>
        </div>
      </>
    );
  };

  const rejectAction = async (prospect) => {
    await rejectProspect(prospect.prospect_id, prospect.prospectType)
      .then((d) => {
        setReload(prospect.prospect_id);
        toastMessage(d?.data?.message, "success");
        handleClose();
      })
      .catch((err) => {
        console.log("err", err);
        toastMessage("error fetching data", "error");
      });
  };

  const approveAction = async (prospect) => {
    await approveProspect(prospect.prospect_id, prospect.prospectType)
      .then((d) => {
        setReload(prospect.prospect_id);
        console.log("object", d?.data);
        toastMessage(d?.data?.message, "success");
        handleClose();
      })
      .catch((err) => {
        console.log("err", err);
        toastMessage("error fetching data", "error");
      });
  };
  const [menuAnchorEl, setMenuAnchorEl] = React.useState(null);
  const [menuProspect, setMenuProspect] = React.useState(null);
  const isMenuOpen = Boolean(menuAnchorEl);
  const openMenu = (event, prospect) => {
    setMenuAnchorEl(event.currentTarget);
    setMenuProspect(prospect);
  };
  const closeMenu = () => {
    setMenuAnchorEl(null);
    setMenuProspect(null);
  };
  return (
    <>
      <Modal open={open} onClose={handleClose}>
        <Box sx={messageStyle} className={styles.main}>
          <div className={styles.header_div}>
            <div style={{ display: "flex" }}>
              <Typography variant="h5" style={{ textDecoration: "underline" }}>
                Prospect Profile
              </Typography>
              <div style={{ display: "flex", marginLeft: "1.5rem" }}>
                <CustomProgessBar
                  size={30}
                  value={data?.jkScore || 0}
                  color={"#fdbc00"}
                  type="JK"
                />
              </div>
              <div style={{ display: "flex", marginLeft: "1.5rem" }}>
                {data?.businessInfo?.gstin ? null : (
                  <p style={{ fontSize: "12px" }}>
                    Inclusive of 12 points,
                    <br /> 6 each for
                    <span style={{ color: "#fdbc00" }}>
                      {" "}
                      cibil and financial.
                    </span>
                  </p>
                )}
              </div>
            </div>
            <div style={{ display: "flex", alignItems: "center" }}>
              {/* <Button variant="contained">Action</Button> */}
              <div style={{ marginRight: "2rem" }}>
                <Button
                  variant="contained"
                  onClick={(e) => openMenu(e, data?.prosStatus)}
                  disabled={
                    !data?.prosStatus
                      ? true
                      : data?.prosStatus?.status?.includes("Pending")
                      ? false
                      : user.user.role == "ADMIN" &&
                        data?.prosStatus?.status == "Pending_HO"
                      ? false
                      : true
                  }
                >
                  {data?.prosStatus ? data?.prosStatus?.status : "N/A"}
                </Button>
                <Menu anchorEl={menuAnchorEl} open={isMenuOpen} onClose={closeMenu}>
                  <MenuItem
                    onClick={() => {
                      if (menuProspect) approveAction(menuProspect);
                      closeMenu();
                    }}
                  >
                    Approve
                  </MenuItem>
                  <MenuItem
                    onClick={() => {
                      if (menuProspect) rejectAction(menuProspect);
                      closeMenu();
                    }}
                  >
                    Reject
                  </MenuItem>
                  <MenuItem
                    onClick={() => {
                      if (menuProspect) remarkAction({ close: closeMenu }, menuProspect);
                      closeMenu();
                    }}
                  >
                    Remark
                  </MenuItem>
                </Menu>
              </div>

              <CloseIcon
                sx={{
                  // border: "1px solid darkgrey",
                  fontSize: "40px",
                  borderRadius: "3px",
                  cursor: "pointer",
                  color: "darkgrey",
                }}
                onClick={handleClose}
              />
            </div>
          </div>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              height: "auto",
              padding: "1rem",
            }}
            className={styles.data_div}
          >
            <div
              style={{
                borderRight: "2px dashed darkgrey",
                // width: "25%",
                padding: "1rem",
              }}
            >
              <p
                style={{
                  fontFamily: "Inter",
                  fontSize: "24px",
                  fontWeight: "400",
                  textAlign: "center",
                  textDecoration: "underline",
                  marginBottom: "2rem",
                }}
              >
                Basic
              </p>
              <p style={{ fontSize: "14px", fontWeight: "600" }}>
                Details of Contact Person - 1
              </p>
              <p>
                <span>Designation :</span>{" "}
                {data?.basicInfo?.firstPersonContact?.designation}
              </p>
              <p>
                <span>Name :</span> {data?.basicInfo?.firstPersonContact?.name}
              </p>
              <p>
                <span>Mobile No :</span>{" "}
                {data?.basicInfo?.firstPersonContact?.phoneNumber}
              </p>
              <p>
                <span>Email :</span>{" "}
                {data?.basicInfo?.firstPersonContact?.email}
              </p>
              <p>
                <span>Preferred Language :</span>{" "}
                {data?.basicInfo?.firstPersonContact?.preferredLanguage}
              </p>
              <p>
                <span>Date of Birth :</span>{" "}
                {data?.basicInfo?.firstPersonContact?.dob
                  ? moment
                      .utc(data?.basicInfo?.firstPersonContact?.dob)
                      .format("YYYY-MM-DD")
                  : "-"}
              </p>
              <p>
                <span>Married :</span>{" "}
                {data?.basicInfo?.firstPersonContact?.maritalStatus}
              </p>
              <p>
                <span>Date of Anniversary :</span>{" "}
                {data?.basicInfo?.firstPersonContact?.anniversaryDob
                  ? moment
                      .utc(data?.basicInfo?.firstPersonContact?.anniversaryDob)
                      .format("YYYY-MM-DD")
                  : "-"}
              </p>
              <p>
                <span>Children :</span>{" "}
                {data?.basicInfo?.firstPersonContact?.children}
              </p>
              <p>
                <span>Qualification :</span>{" "}
                {data?.basicInfo?.firstPersonContact?.qualification}
              </p>
              <p>
                <span>Pan Number :</span>{" "}
                {data?.basicInfo?.firstPersonContact?.panNo}
                {/* <span
                  style={{
                    color: "green",
                    fontWeight: "700",
                    marginLeft: "10px",
                  }}
                >
                  {data?.basicInfo?.firstPersonContact?.panNo ? "+6" : "+0"}
                </span> */}
              </p>
              <p style={{ color: "blue", fontWeight: "600" }}>
                <span style={{ color: "blue" }}>Experience :</span>{" "}
                {
                  data?.basicInfo?.firstPersonContact?.businessExperience
                    ?.noofyears
                }
                <span
                  style={{
                    color: "green",
                    fontWeight: "700",
                    marginLeft: "10px",
                  }}
                >
                  +
                  {data?.basicInfo?.firstPersonContact?.businessExperience
                    ?.noofyears
                    ? experinceScore(
                        data?.basicInfo?.firstPersonContact?.businessExperience
                          ?.noofyears
                      )
                    : 6}
                </span>
              </p>
              <p style={{ color: "blue", fontWeight: "600" }}>
                <span>Industry :</span>{" "}
                {data?.businessInfo?.businessCouterCompanies
                  ? data?.businessInfo?.businessCouterCompanies.join(", ")
                  : "-"}
                <span
                  style={{
                    color: "green",
                    fontWeight: "700",
                    marginLeft: "10px",
                  }}
                >
                  +{industryScore(data?.businessInfo?.businessCouterCompanies)}
                </span>
              </p>
              <p>
                <span>Work Experience :</span>{" "}
                {data?.basicInfo?.firstPersonContact?.workExperience?.noofyears}
              </p>
              <p>
                <span>Assosiated Industries :</span>{" "}
                {data?.basicInfo?.firstPersonContact?.workExperience?.industry}
              </p>
              <p>
                <span>Assosiated Company :</span>{" "}
                {data?.basicInfo?.firstPersonContact?.workExperience?.company}
              </p>
              <p>
                <span>Assosiated with JK :</span>{" "}
                {data?.basicInfo?.firstPersonContact?.assosiatedwithJK}
              </p>

              {data?.basicInfo?.secondPersonContact ? (
                <>
                  <p
                    style={{
                      fontSize: "14px",
                      fontWeight: "600",
                      marginTop: "2rem",
                    }}
                  >
                    Details of Contact Person - 2
                  </p>
                  <p>
                    <span>Designation :</span>{" "}
                    {data?.basicInfo?.secondPersonContact?.designation}
                  </p>
                  <p>
                    <span>Name :</span>{" "}
                    {data?.basicInfo?.secondPersonContact?.name}
                  </p>
                  <p>
                    <span>Mobile No :</span>{" "}
                    {data?.basicInfo?.secondPersonContact?.phoneNumber}
                  </p>
                  <p>
                    <span>Email :</span>{" "}
                    {data?.basicInfo?.secondPersonContact?.email}
                  </p>
                  <p>
                    <span>Preferred Language :</span>{" "}
                    {data?.basicInfo?.secondPersonContact?.preferredLanguage}
                  </p>
                  <p>
                    <span>Date of Birth :</span>{" "}
                    {data?.basicInfo?.secondPersonContact?.dob
                      ? moment
                          .utc(data?.basicInfo?.secondPersonContact?.dob)
                          .format("YYYY-MM-DD")
                      : "-"}
                  </p>
                  <p>
                    <span>Married :</span>{" "}
                    {data?.basicInfo?.secondPersonContact?.maritalStatus}
                  </p>
                  <p>
                    <span>Date of Anniversary :</span>{" "}
                    {data?.basicInfo?.secondPersonContact?.anniversaryDob
                      ? moment
                          .utc(
                            data?.basicInfo?.secondPersonContact?.anniversaryDob
                          )
                          .format("YYYY-MM-DD")
                      : "-"}
                  </p>
                  <p>
                    <span>Children :</span>{" "}
                    {data?.basicInfo?.secondPersonContact?.children}
                  </p>
                  <p>
                    <span>Qualification :</span>{" "}
                    {data?.basicInfo?.secondPersonContact?.qualification}
                  </p>
                  <p>
                    <span>Pan Number :</span>{" "}
                    {data?.basicInfo?.secondPersonContact?.panNo}
                  </p>
                  <p>
                    <span>Business Experience :</span>{" "}
                    {
                      data?.basicInfo?.secondPersonContact?.businessExperience
                        ?.noofyears
                    }
                  </p>
                  <p>
                    <span>Assosiated Industries (Business) :</span>{" "}
                    {
                      data?.basicInfo?.secondPersonContact?.businessExperience
                        ?.industry
                    }
                  </p>
                  <p>
                    <span>Assosiated Company (Business) :</span>{" "}
                    {
                      data?.basicInfo?.secondPersonContact?.businessExperience
                        ?.company
                    }
                  </p>

                  <p>
                    <span>Work Experience :</span>{" "}
                    {
                      data?.basicInfo?.secondPersonContact?.workExperience
                        ?.noofyears
                    }
                  </p>
                  <p>
                    <span>Assosiated Industries (Work) :</span>{" "}
                    {
                      data?.basicInfo?.secondPersonContact?.workExperience
                        ?.industry
                    }
                  </p>
                  <p>
                    <span>Assosiated Company (Work) :</span>{" "}
                    {
                      data?.basicInfo?.secondPersonContact?.workExperience
                        ?.company
                    }
                  </p>
                  {/* <p style={{ color: "blue", fontWeight: "600" }}>
                    <span>Industry :</span>{" "}
                    {data?.businessInfo?.businessCouterCompanies
                      ? data?.businessInfo?.businessCouterCompanies.join(", ")
                      : "-"}
                    <span
                      style={{
                        color: "green",
                        fontWeight: "700",
                        marginLeft: "10px",
                      }}
                    >
                      +
                      {industryScore(
                        data?.businessInfo?.businessCouterCompanies
                      )}
                    </span>
                  </p> */}
                  <p>
                    <span>Assosiated with JK :</span>{" "}
                    {data?.basicInfo?.secondPersonContact?.assosiatedwithJK}
                  </p>
                </>
              ) : null}
            </div>
            <div
              style={{
                borderRight: "2px dashed darkgrey",
                padding: "1rem",
                // width: "25%",
              }}
            >
              <p
                style={{
                  fontFamily: "Inter",
                  fontSize: "24px",
                  fontWeight: "400",
                  textAlign: "center",
                  textDecoration: "underline",
                  marginBottom: "2rem",
                }}
              >
                Address
              </p>
              <p style={{ fontSize: "14px", fontWeight: "600" }}>
                Registered Outlet as per GST
              </p>
              <p>{data?.businessInfo?.addressGST?.streetNumber}</p>
              <p>{data?.businessInfo?.addressGST?.address2}</p>
              <p>{data?.businessInfo?.addressGST?.address3}</p>
              <p>{data?.businessInfo?.addressGST?.districtName}</p>
              <p>{data?.businessInfo?.addressGST?.state}</p>
              <p>{data?.businessInfo?.addressGST?.pincode}</p>
              <p style={{ color: "blue", fontWeight: "600" }}>
                {data?.businessInfo?.addressGST?.areaSelection
                  ? data?.businessInfo?.addressGST?.areaSelection
                  : "NA"}{" "}
                <span
                  style={{
                    color: "green",
                    fontWeight: "700",
                    marginLeft: "10px",
                  }}
                >
                  {data?.businessInfo?.addressGST?.areaSelection
                    ? `+
                    ${locationScore(
                      data?.businessInfo?.addressGST?.areaSelection
                    )}`
                    : "+6"}
                </span>
              </p>

              <p
                style={{
                  fontSize: "14px",
                  fontWeight: "600",
                  marginTop: "1rem",
                }}
              >
                Address (Steel Wheels/ Xpress Wheels/Truck Wheels)
              </p>

              <p>{data?.businessInfo?.addressBrandShop?.streetNumber}</p>
              <p>{data?.businessInfo?.addressBrandShop?.address2}</p>
              <p>{data?.businessInfo?.addressBrandShop?.address3}</p>
              <p>{data?.businessInfo?.addressBrandShop?.districtName}</p>
              <p>{data?.businessInfo?.addressBrandShop?.state}</p>
              <p>{data?.businessInfo?.addressBrandShop?.pincode}</p>

              <p
                style={{
                  fontSize: "14px",
                  fontWeight: "600",
                  marginTop: "1rem",
                }}
              >
                Location of Proposed Outlet
              </p>

              <p>{data?.businessInfo?.proposedOutletAddress?.streetNumber}</p>
              <p>{data?.businessInfo?.proposedOutletAddress?.address2}</p>
              <p>{data?.businessInfo?.proposedOutletAddress?.address3}</p>
            </div>
            <div
              style={{
                borderRight: "2px dashed darkgrey",
                padding: "1rem",
                maxHeight: "100%",
                overflowY: "auto",
              }}
            >
              <p
                style={{
                  fontFamily: "Inter",
                  fontSize: "24px",
                  fontWeight: "400",
                  textAlign: "center",
                  textDecoration: "underline",
                  marginBottom: "2rem",
                }}
              >
                Business
              </p>
              <p>
                <span>Dealership Name:</span>{" "}
                {data?.businessInfo?.dealershipName}
              </p>
              <p>
                <span>Email:</span> {data?.businessInfo?.email}
              </p>
              <p>
                <span>Contact Number:</span>
                {data?.businessInfo?.phoneNumber}
              </p>
              <p>
                <span>Landline Number:</span> {data?.businessInfo?.landline}
              </p>
              <p style={{ color: "blue", fontWeight: "600" }}>
                <span style={{ color: "blue" }}>GST Number:</span>{" "}
                {data?.businessInfo?.gstin}
                <span
                  style={{
                    color: "green",
                    fontWeight: "700",
                    marginLeft: "10px",
                  }}
                >
                  {data?.businessInfo?.gstin ? `+12` : "+0"}
                </span>
              </p>
              <p>
                <span>Pan Number</span> {data?.businessInfo?.panCard}
              </p>
              <p>
                <span>Firm Type</span> {data?.businessInfo?.natureOfFirm}
              </p>
              <p>
                <span>Last 3 Year Turnover : </span>{" "}
                {data?.businessInfo?.turnOver}
              </p>
              <p>
                <span>Date of Incorporation : </span>{" "}
                {data?.businessInfo?.dateOfIncorporation
                  ? moment
                      .utc(data?.businessInfo?.dateOfIncorporation)
                      .format("YYYY-MM-DD")
                  : "-"}
              </p>
              <p>
                <span>Account Type : </span> {data?.businessInfo?.accountType}
              </p>
              <p style={{ color: "blue", fontWeight: "600" }}>
                Proposed SAS: {data?.businessInfo?.proposedSAS}
                <span
                  style={{
                    color: "green",
                    fontWeight: "700",
                    marginLeft: "10px",
                  }}
                >
                  {data?.businessInfo?.proposedSAS
                    ? `+
                    ${jkpotentialScore(
                      data?.businessInfo?.businessCouterSaleValue,
                      data?.businessInfo?.proposedSAS
                    )}`
                    : "+6"}
                </span>
              </p>
              <p>
                <span>Proposed Business Share:</span>{" "}
                {data?.businessInfo?.proposedBusinessShare}
              </p>
              {/* <p>
                <span>Experience:</span>{" "}
                {data?.basicInfo?.firstPersonContact?.workExperience?.noofyears}
              </p>
              <p>
                <span>Industry:</span>{" "}
                {data?.basicInfo?.firstPersonContact?.workExperience?.industry
                  ? data?.basicInfo?.firstPersonContact?.workExperience
                      ?.industry
                  : "-"}
              </p>
              <p>
                <span>Assosiated Company:</span>{" "}
                {data?.basicInfo?.firstPersonContact?.workExperience?.company
                  ? data?.basicInfo?.firstPersonContact?.workExperience?.company
                  : "-"}
              </p> */}

              <p
                style={{
                  fontWeight: "600",
                  fontSize: "16px",
                  marginTop: "1rem",
                }}
              >
                Prospect Reputation
              </p>
              <p
                style={{
                  fontWeight: "600",
                  fontSize: "14px",
                  color: "darkgrey",
                }}
              >
                {data?.businessInfo?.proposedOutletAddress?.optionSelection
                  ? data?.businessInfo?.proposedOutletAddress?.optionSelection
                  : null}
                <span
                  style={{
                    color: "green",
                    fontWeight: "700",
                    marginLeft: "10px",
                  }}
                >
                  {data?.businessInfo?.proposedOutletAddress?.optionSelection
                    ? `+
                    ${reputationScore(
                      data?.businessInfo?.proposedOutletAddress?.optionSelection
                    )}`
                    : "+6"}
                </span>
              </p>

              <p
                style={{
                  fontWeight: "600",
                  padding: "1rem 0",
                  fontSize: "16px",
                }}
              >
                Category wise business proposed & Share of Business
              </p>
              {data?.businessInfo?.proposedBusinessByCategory &&
              data?.businessInfo?.proposedBusinessByCategory.length > 0 ? (
                <div style={{ paddingBottom: "1rem" }}>
                  {data?.businessInfo?.proposedBusinessByCategory.map(
                    (p, idx) => (
                      <>
                        <p
                          style={{
                            fontSize: "14px",
                            fontWeight: "600",
                            marginTop: `${idx > 0 ? "1rem" : "0"}`,
                          }}
                        >
                          {p?.category}
                        </p>
                        <p style={{ fontWeight: "600", marginTop: "5px" }}>
                          SAS:{" "}
                          <span
                            style={{ color: "darkgray", fontWeight: "600" }}
                          >
                            {p?.sas}
                          </span>
                        </p>
                        <p style={{ fontWeight: "600" }}>
                          Business Share:{" "}
                          <span
                            style={{ color: "darkgray", fontWeight: "600" }}
                          >
                            {p?.share}
                          </span>
                        </p>
                      </>
                    )
                  )}
                </div>
              ) : null}
            </div>
            <div style={{ padding: "1rem" }}>
              <p
                style={{
                  fontFamily: "Inter",
                  fontSize: "24px",
                  fontWeight: "400",
                  textAlign: "center",
                  textDecoration: "underline",
                  marginBottom: "2rem",
                }}
              >
                Potential
                <span
                  style={{
                    color: "green",
                    fontWeight: "700",
                    marginLeft: "10px",
                  }}
                >
                  +
                  {potentialScore(
                    data?.businessInfo?.businessCouterSaleValue,
                    data?.businessInfo?.proposedSAS
                  )}
                </span>
              </p>
              {data?.businessInfo?.businessCouterSaleValue &&
              data?.businessInfo?.businessCouterSaleValue.length > 0 ? (
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "5px",
                  }}
                >
                  {data?.businessInfo?.businessCouterSaleValue.map((p, idx) => (
                    <>
                      <p
                        style={{
                          color: "blue",
                          fontWeight: "600",
                          fontSize: "14px",
                          fontWeight: "600",
                          // marginBottom: "10px",
                          marginTop: `${idx > 0 ? "1rem" : "0"}`,
                        }}
                      >
                        {p?.companyName}
                      </p>
                      {p?.proposedBusinessByCategory &&
                      p?.proposedBusinessByCategory.length > 0 ? (
                        <>
                          {p?.proposedBusinessByCategory.map((cat) => (
                            <>
                              <p>
                                {cat?.category} :{" "}
                                {cat?.switchValue === false
                                  ? "Direct"
                                  : "Indirect"}{" "}
                                {" | "}
                                {cat?.sas}
                              </p>
                            </>
                          ))}
                        </>
                      ) : null}
                    </>
                  ))}
                </div>
              ) : null}
            </div>
          </div>
        </Box>
      </Modal>
    </>
  );
};

export default DealerProspectView;
